import { GameEvent } from '../types';

type EventHandler = (...args: unknown[]) => void;

export class EventBus {
  private listeners: Map<GameEvent, Set<EventHandler>> = new Map();

  on(event: GameEvent, handler: EventHandler): void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(handler);
  }

  off(event: GameEvent, handler: EventHandler): void {
    const handlers = this.listeners.get(event);
    if (handlers) {
      handlers.delete(handler);
    }
  }

  emit(event: GameEvent, ...args: unknown[]): void {
    const handlers = this.listeners.get(event);
    if (handlers) {
      for (const handler of handlers) {
        try {
          handler(...args);
        } catch (e) {
          console.error(`[EventBus] Error in handler for ${event}:`, e);
        }
      }
    }
  }

  removeAllListeners(): void {
    this.listeners.clear();
  }
}
